export default __webpack_public_path__ + "static/covid-19-mererue-a2076de0c4b46226b76d694328c6640b.jpg";